
import { RevContainer } from '@ds/components/Container'
import { RevLink } from '@ds/components/Link'
import isEmpty from 'lodash/isEmpty'

import Breadcrumb from '@app/components/Breadcrumb'
import { buyingGuideHubFetch, buyingGuideHubFooterLinks } from '@http/endpoints'
import { trackClick } from '@tracking/events'

import BuyingGuideCard from '../../components/Card'
import Category from '../../components/Category'
import Footer from '../../components/Footer'
import RteParser from '../../components/RteParser'
import { buildBreadcrumb } from '../../helpers'

import translations from './LayoutHub.translations'

const TEXT_MAX_SIZE = 500

export default {
  components: {
    RevLink,
    Breadcrumb,
    BuyingGuideCard,
    Category,
    RevContainer,
    Footer,
    RteParser,
  },
  async asyncData({ store, params, redirect, error, $config }) {
    const country = store.getters['config/country']
    const hubId = params.unifiedName
    const useNewLayout = $config.FF_ARTICLE_PAGE_BY_COUNTRY.includes(country)

    try {
      const [{ payload: hub }, { payload: footer }] = await Promise.all([
        store.dispatch('http/request', {
          request: buyingGuideHubFetch,
          pathParams: {
            id: hubId,
          },
        }),
        store
          .dispatch('http/request', {
            request: buyingGuideHubFooterLinks,
            pathParams: { id: hubId },
          })
          .catch(() => {
            return { payload: [] }
          }),
      ])

      if (hub.countryCode !== country) {
        return error({
          statusCode: 404,
          message: 'Hub not available in this country',
        })
      }

      const breadcrumb = buildBreadcrumb(hub.breadcrumb)

      if (
        params.categories &&
        params.categories !== breadcrumb.pageSlug.params.categories
      ) {
        return redirect(301, {
          name: breadcrumb.pageSlug.name,
          type: breadcrumb.pageSlug.type,
          params: { ...breadcrumb.pageSlug.params },
        })
      }

      const categories = !isEmpty(hub.categories)
        ? hub.categories.filter(({ featured }) => !isEmpty(featured))
        : []

      const footerFiltered = !isEmpty(footer)
        ? footer.filter(({ subCategories }) => !isEmpty(subCategories))
        : []

      return {
        ...hub,
        categories,
        breadcrumb,
        footer: footerFiltered,
        useNewLayout,
      }
    } catch (err) {
      return error({
        statusCode: 404,
        message: `Details not found for ${
          params.unifiedName ? `hub with id ${params.unifiedName}` : 'root hub'
        }`,
      })
    }
  },
  data() {
    return {
      title: '',
      intro: '',
      featured: [],
      buyingGuides: [],
      categories: [],
      isIntroHidden: null,
      breadcrumb: [],
      footer: [],
      rawIntro: '',
      useNewLayout: false,
    }
  },
  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.rawIntro,
        },
        {
          content: this.title,
          property: 'og:title',
          hid: 'og:title',
        },
        {
          content: this.rawIntro,
          property: 'og:description',
          hid: 'og:description',
        },
        {
          content: this.title,
          property: 'twitter:title',
          hid: 'twitter:title',
        },
        {
          content: this.rawIntro,
          property: 'twitter:description',
          hid: 'twitter:description',
        },
      ],
    }
  },
  computed: {
    translations: () => translations,
    isLastLevel() {
      return !isEmpty(this.buyingGuides) && isEmpty(this.categories)
    },
    displayBreadcrumb() {
      return !isEmpty(this.breadcrumb)
    },
    hasFooter() {
      return !isEmpty(this.footer)
    },
    hasFeatured() {
      return !isEmpty(this.featured)
    },
    featuredCategory() {
      return {
        displayName: this.$t(translations.featuredTitle),
        featured: this.featured,
      }
    },
  },
  mounted() {
    const { introRef } = this.$refs
    this.rawIntro = introRef.$el.textContent.trim()
    this.isIntroHidden = this.rawIntro.length > TEXT_MAX_SIZE
  },
  methods: {
    sendMarketingData(value) {
      trackClick({
        name: 'breadcrumb',
        zone: 'hubBuyingGuide',
        value: {
          breadcrumbValue: value.title,
        },
      })
    },
  },
}
